import { css } from '@emotion/core';
import styled from '@emotion/styled';
import { Heading } from '../../components';

const wrapperStyles = ({
  blogThemeConfig,
  theme: {
    color,
    font: { color: fontColor },
    grid: { breakpoint },
  },
}) => css`
  padding-top: 15px;
  padding-right: 15px;
  padding-bottom: 15px;
  padding-left: 15px;
  background: ${blogThemeConfig.background};
  ${blogThemeConfig.background.includes('gradient') ? `filter: saturate(150%)` : null};
  color: ${fontColor[blogThemeConfig.color]};
  ${breakpoint.fromDesktop} {
    padding-top: 30px;
    padding-right: 30px;
    padding-bottom: 30px;
    padding-left: 30px;
  }
  ${'' /*
  TODO: Update after adding HeyLikey :-)
  ${breakpoint.fromPhoneMedium} {
    padding-left: 150px;
  } */}
  &:not(:last-of-type) {
    border-bottom: 1px solid ${blogThemeConfig.background !== color.white ? 'none' : color.grey900Transparent15};
  }
  &:first-of-type {
    margin-top: ${blogThemeConfig.background === '#fff' ? '-15px' : 'initial'};
    ${breakpoint.fromDesktop} {
      margin-top: ${blogThemeConfig.background === '#fff' ? '-30px' : 'initial'};
    }
  }
`;

const headerStyles = ({
  postKind,
  theme: {
    grid: { breakpoint },
  },
}) => css`
  margin: ${postKind === 'quote' ? '90px 0' : '15px 0 25px'};
  text-align: ${postKind === 'quote' ? 'center' : 'left'};
  ${breakpoint.fromDesktop} {
    margin: ${postKind === 'quote' ? '120px 0' : '15px 0 25px'};
  }
`;

const blogItemHeadingStyles = ({ postKind }) => css`
  margin: 0 0 ${postKind === 'quote' ? 0 : '10px'};
`;

const imageWrapperStyles = ({
  theme: {
    grid: { breakpoint },
  },
}) => css`
  margin: 30px 0 15px;
  ${breakpoint.fromDesktop} {
    margin: 30px 0 25px 0;
  }
`;

/**
 * Component style declarations
 */
export const Wrapper = styled('article')(wrapperStyles);
export const Header = styled('header')(headerStyles);
export const BlogItemHeading = styled(Heading)(blogItemHeadingStyles);
export const ImageWrapper = styled('figure')(imageWrapperStyles);
